import { Component, OnInit } from '@angular/core';
import { AddTrainingsService } from './add-trainings.service';
import { CompetencyDropdownModel } from 'src/app/Models/competencyDropdownModel';
import { TrainerModel } from 'src/app/Models/trainerModel';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SubCompetencyDropdownModel } from 'src/app/Models/subCompetencyDropDownModel';
import { AddTrainingsModel } from 'src/app/Models/addTrainingsModel';
import { TrainingTypeModel } from 'src/app/Models/trainingTypeModel';
import { ToastrService } from "ngx-toastr";
import { TrainingsTrackerService } from '../../trainings_tracker/trainings_tracker_header/trainings_tracker.service';
import { LocationsModel } from 'src/app/Models/locationsModel';
import { Router } from '@angular/router';
import { toUnicode } from 'punycode';
import { TrainingModeModel } from 'src/app/Models/trainingModeModel';
import { OthersService } from 'src/app/views/competencies/others/othersDataService';
import { CompetenciesService } from '../../competencies/competencies.service';


@Component({
  selector: 'app-add-trainings',
  templateUrl: './add-trainings.component.html',
  styleUrls: ['./add-trainings.component.css']
})

export class AddTrainingsComponent implements OnInit {

  public serviceLinesValues: CompetencyDropdownModel[];
  public subServiceLinesValues: SubCompetencyDropdownModel[];
  subCompetenciesdropdown: SubCompetencyDropdownModel[];
  selectedServiceLine:any;
  public TrainerNameValue: TrainerModel[];
  public sessionTypeValues: TrainingTypeModel[];
  public sessionLocationValues: LocationsModel[];
  public emails: string[];
  public emailInput: string;
  public emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  public invalidEmails: string[] = [];
  public saveTrainingDetails: AddTrainingsModel = new AddTrainingsModel();
  public editTrainingDetails: AddTrainingsModel = new AddTrainingsModel();
  public AddTrainingsForm: FormGroup;
  public isEmailCount: boolean = false;
  public editedEmailString: string;
  

  public selectedServicelineValues: CompetencyDropdownModel[];
  public selectedServicelineId: number = null;
  selectedServicelinename: CompetencyDropdownModel[];
  public editedServicelineValues: CompetencyDropdownModel[];

  public selectedSubServicelineValues: SubCompetencyDropdownModel[];
  selectedSubCompetencyId: SubCompetencyDropdownModel[];
  public editedSubServicelineValues: SubCompetencyDropdownModel[];
  public selectedSubServicelineId: number = null;

  public selectedTrainingLocationId: number = null;
  public selectedLocationValues: LocationsModel[];
  public editedLocationValues: LocationsModel[];

  public selectedTrainingTypeId: number = null;
  public selectedTrainingTypeValues: TrainingTypeModel[];

  public selectedTrainerId: number = null;
  public selectedTrainerValues: TrainerModel[];
  

  public createButton: boolean = true;
  public editButton: boolean = false;
  public isCopy: boolean = false;
  public copyButton: boolean = false;
  public isViewMode: boolean = false;
  public viewButton: boolean = false;

  public minEndDateValue: Date;
  public isValidEndDate: boolean = true;
  public isValidStartDate: boolean = true;

  public TrainerNameText:any;

  public selectedTrainingModeId: number = null;
  public selectedTrainingModeValues: TrainingModeModel[];
  public trainingModeValues: TrainingModeModel[]= [  
    {  
      "id": 1,  
      "name": "Online",  
    }, 
    {  
      "id": 2,  
      "name": "Offline",  
    },
    {  
      "id": 3,  
      "name": "Online/Offline",  
    }, ]
  selectedName: any;
  competencyname:string=''
  subCompetencyName:string=''
  trainingTypeId:number;
  trainingTypeName:string=''
  constructor(
    private service: AddTrainingsService,
    private toastr: ToastrService,
    private _service: TrainingsTrackerService,
    private compservice:CompetenciesService,
    private othersService: OthersService,
    private router: Router,) {

    this.AddTrainingsForm = new FormGroup({
      serviceLines: new FormControl('', [Validators.required]),
      subServiceline: new FormControl('', [Validators.required]),
      sessionName: new FormControl('', [Validators.required]),
      trainerName: new FormControl('', [Validators.required]),
      sessionType: new FormControl('', [Validators.required]),
      sessionMode: new FormControl('', [Validators.required]),
      startDate: new FormControl('', [Validators.required]),
      endDate: new FormControl({ value: '', disabled: true }, [Validators.required]),
      noofPlannedResources: new FormControl('', [Validators.required]),
      toolsRequired: new FormControl('', [Validators.required]),
      sessionURL: new FormControl('', [Validators.required]),
      emailInputString: new FormControl(''),
      sessionLocation: new FormControl('', [Validators.required]),
    });
  }

  ngOnInit() {
    this.resetForm() 
    this.service.getAllServiceLines().subscribe(res => {
      this.serviceLinesValues = res.data;

      this._service.getFormData().subscribe(response => {
        this.editTrainingDetails = response;
        if (Object.keys(this.editTrainingDetails).length != 0) {
          this._service.getCopyButtonStatus().subscribe(response => {
            this.isCopy = response;
            if (this.isCopy == true) {
              this.editButton = false;
              this.copyButton = true;
              this.createButton = false;

            }
            else {
              this.editButton = true;
              this.copyButton = false;
              this.createButton = false;
            }
          })

          this._service.getViewButtonStatus().subscribe(response => {
            this.isViewMode = response;
            if (this.isViewMode == true) {
              this.viewButton = true;
            }
            else {
              this.viewButton = false;
              this.AddTrainingsForm.enable();
            }
          })

          for (let i of this.serviceLinesValues) {
            if (i.id == this.editTrainingDetails.competencyId) {
              this.selectedServicelineId = i.id
            }
          }

          this.service.getCompetencyName(this.selectedServicelineId).subscribe(res => {
            this.subServiceLinesValues = res.data;
            for (let i of this.subServiceLinesValues) {
              if (i.id == this.editTrainingDetails.subCompetencyId) {
                this.selectedSubServicelineId = i.id
              }
            }
          })

          this.editForm();
          if (this.isViewMode == true) {
            this.AddTrainingsForm.disable();
          }

        }
      });
    })


    this.service.getSessionLocations().subscribe(res => {
      this.sessionLocationValues = res;
      for (let i of this.sessionLocationValues) {
        if (i.id == this.editTrainingDetails.locationId) {
          this.selectedTrainingLocationId = i.id
        }
      }
    })

    this.service.getSessionType().subscribe(res => {
      this.sessionTypeValues = res;
      for (let i of this.sessionTypeValues) {
        if (i.id == this.editTrainingDetails.typeId) {
          this.selectedTrainingTypeId = i.id
        }
      }
    })
    this.compservice.competencyName$.subscribe(x => { this.competencyname = x
      if (this.competencyname== null||this.competencyname=="") {
        this.competencyname = sessionStorage.getItem("compTitle")
      } 
    });
    this.othersService.name$.subscribe(name => {
      this.subCompetencyName = name;
      if (this.subCompetencyName== null||this.subCompetencyName== "") {
        this.subCompetencyName = sessionStorage.getItem("SubcompTitle")
      }
    })
    this.othersService.triningtypeid$.subscribe(value => {
      this.trainingTypeId = value.value;
      this.trainingTypeName = value.name
      if (this.trainingTypeId== null || this.trainingTypeId==0) {
        this.trainingTypeId=Number(sessionStorage.getItem("TrainingtypeId"))
      }
      if (this.trainingTypeName== null || this.trainingTypeName== "") {
        this.trainingTypeName=sessionStorage.getItem("TrainingTypename")
      }

  });
}

  createTraining() {
    this.emailInput = this.AddTrainingsForm.controls['emailInputString'].value
    this.saveTrainingDetails.competencyId = this.selectedServicelineValues[0].competencyId;
    this.saveTrainingDetails.subCompetencyId = this.selectedSubServicelineValues[0].id;
    this.saveTrainingDetails.serviceLineId = this.selectedServiceLine.id;
    this.saveTrainingDetails.trainingName = this.AddTrainingsForm.controls['sessionName'].value;
    this.saveTrainingDetails.trainerId = this.selectedTrainerId;
    this.saveTrainingDetails.typeId = this.selectedTrainingTypeValues[0].id;
    this.saveTrainingDetails.trainingModeId = this.selectedTrainingModeValues[0].id;
    this.saveTrainingDetails.locationId = this.selectedLocationValues[0].id;
    this.saveTrainingDetails.startDate = this.AddTrainingsForm.controls['startDate'].value;
    this.saveTrainingDetails.endDate = this.AddTrainingsForm.controls['endDate'].value;
    this.saveTrainingDetails.plannedResourcesCount = this.AddTrainingsForm.controls['noofPlannedResources'].value;
    this.saveTrainingDetails.prerequisiteTools = this.AddTrainingsForm.controls['toolsRequired'].value;
    this.saveTrainingDetails.trainingRecordingSharePointURL = this.AddTrainingsForm.controls['sessionURL'].value;
    this.saveTrainingDetails.attendeeEmails = this.emails;

    this.service.addTrainingDetails(this.saveTrainingDetails).subscribe(res => {
      this.toastr.success("Training created Successfully");
      this.resetForm();
      this.compservice.setProfileStatus(this.saveTrainingDetails.competencyId);
      this.othersService.updateId(this.saveTrainingDetails.subCompetencyId);
      this.othersService.updatetriningtypeId(this.saveTrainingDetails.typeId);
      const sendData = {
        value: this.trainingTypeId,
        name: this.trainingTypeName,
      }
      this.subCompetencyName=this.subCompetencyName.replace(/\//g, '');
      this.subCompetencyName=this.subCompetencyName.split(' ').join('');
      this.router.navigate([`Home/Competencies/${this.competencyname}/${this.subCompetencyName}/Trainings/${sendData.name}`]);
    })
  }

  searchContributor(data: string) {
    if (data.length >= 3) {
      this.service.getTrainerDetails(data).subscribe(res => {
        this.TrainerNameValue = res.data.profiles;
      })
    }
  }


  selectedTrainerName(event: any){
    this.selectedName = event.option.value;
    this.TrainerNameValue.forEach(val=>{
      if(val.name == this.selectedName){
        this.selectedTrainerId = val.employeeId
      }
    })
  }


  subCompetencies() {
    this.selectedServicelineValues = this.serviceLinesValues.filter(x => x.competencyId == this.selectedServiceLine.competencyId);
    this.service.getCompetencyName(this.selectedServiceLine.competencyId).subscribe(res => {
      this.subServiceLinesValues = res.data;
      this.selectedServicelineId = res.data.competencyId;
      this.selectedServicelinename = res.data.name;

    })
    this.compservice.getSubCompetenciesForDropDowns(this.selectedServiceLine.competencyId).subscribe(res => {
      this.subCompetenciesdropdown=res.data;
    })

    }
  

  getSubserviceLines(input: number) {
    this.selectedSubServicelineValues = this.subCompetenciesdropdown.filter(x => x.id == input);
  }

  getLocationId(input: number) {
    this.selectedLocationValues = this.sessionLocationValues.filter(x => x.id == input);
  }

  getSessionTypeId(input: number) {
    this.selectedTrainingTypeValues = this.sessionTypeValues.filter(x => x.id == input);
  }

  getSessionModeId(input: number){
    this.selectedTrainingModeValues = this.trainingModeValues.filter(x => x.id == input);
   

  }

  validateEmails(emails: string[]): boolean {
    let isValidEmails = true;
    for (let email of emails) {
      if (!this.emailRegex.test(email)) {
        this.invalidEmails.push(email);
        isValidEmails = false;
      }
    }
    return isValidEmails;
  }

  emailValidator() {
    this.invalidEmails = [];
    this.emailInput = this.AddTrainingsForm.controls['emailInputString'].value
    if (this.emailInput != null) {
      this.emailInput = this.emailInput.replace(/^;+|;\s*$/, "");
      this.emailInput = this.emailInput.trim();
      this.emails = this.emailInput.split(';');
      this.emails = this.emails.filter(function (x) {
        return x !== '';
      });
      this.validateEmails(this.emails);

    }
  }

  emailCount() {
    if (this.emails != null) {
      const resourcess = this.AddTrainingsForm.controls['noofPlannedResources'].value;
      const emailss = this.emails.length;
      if (resourcess < emailss) {
        this.isEmailCount = true
      }
      else {
        this.isEmailCount = false;
      }
    }
  }

  resetForm() {
    this.AddTrainingsForm.reset();
  }

  dateToday(): Date {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();
    const hour = now.getHours();
    const minute = now.getMinutes();
    return new Date(year, month, day, hour, minute);
  }

  enableEndDate(input:Date) {
    var currentTime: number = new Date().getTime();
    var todayDate: number = new Date().getDate();

    var selectedStartTime: number = new Date(input).getTime();
    var selectedStartDate: number = new Date(input).getDate();

    if (todayDate == selectedStartDate) {
      if (currentTime > selectedStartTime) {
        this.isValidStartDate = false;
      }
      else {
        this.isValidStartDate = true;
        this.AddTrainingsForm.controls['endDate'].enable();
        this.AddTrainingsForm.controls['endDate'].reset();
      }
    }
    else {
      this.isValidStartDate = true;
      this.AddTrainingsForm.controls['endDate'].enable();
      this.AddTrainingsForm.controls['endDate'].reset();
    }
  }

  validateEndTime(input:Date) {
    var startDateValue = this.AddTrainingsForm.controls['startDate'].value;
    var startTime: number = new Date(startDateValue).getTime();
    var dateStart: number = new Date(startDateValue).getDate();

    var endTime: number = new Date(input).getTime();
    var dateEnd: number = new Date(input).getDate();

    if (dateStart == dateEnd) {
      if (startTime > endTime) {
        this.isValidEndDate = false;
      }
      else {
        this.isValidEndDate = true;
      }
    }
  }

  editForm() {
    if (this.editTrainingDetails.attendeeEmails != null) {
      this.editedEmailString = this.editTrainingDetails.attendeeEmails.toString();
      this.editedEmailString = this.editedEmailString.replace(",", ";");
    }

    this.AddTrainingsForm = new FormGroup({
      serviceLines: new FormControl(this.editTrainingDetails.competencyId, [Validators.required]),
      subServiceline: new FormControl(this.editTrainingDetails.subCompetencyId, [Validators.required]),
      sessionName: new FormControl(this.editTrainingDetails.trainingName, [Validators.required]),
      trainerName: new FormControl(this.editTrainingDetails.trainerName, [Validators.required]),
      sessionType: new FormControl(this.editTrainingDetails.typeId, [Validators.required]),
      sessionMode: new FormControl(this.editTrainingDetails.trainingModeId, [Validators.required]),
      startDate: new FormControl(this.editTrainingDetails.startDate, [Validators.required]),
      endDate: new FormControl(this.editTrainingDetails.endDate, [Validators.required]),
      noofPlannedResources: new FormControl(this.editTrainingDetails.plannedResourcesCount, [Validators.required]),
      toolsRequired: new FormControl(this.editTrainingDetails.prerequisiteTools, [Validators.required]),
      sessionURL: new FormControl(this.editTrainingDetails.trainingRecordingSharePointURL, [Validators.required]),
      emailInputString: new FormControl(this.editedEmailString),
      sessionLocation: new FormControl(this.editTrainingDetails.locationId, [Validators.required]),
    });
  }

  editTraining() {
    this.emailInput = this.AddTrainingsForm.controls['emailInputString'].value

    this.saveTrainingDetails.id = this.editTrainingDetails.id;

    this.saveTrainingDetails.competencyId = JSON.parse(this.AddTrainingsForm.controls['serviceLines'].value);
   
    this.saveTrainingDetails.subCompetencyId = JSON.parse(this.AddTrainingsForm.controls['subServiceline'].value);
    this.saveTrainingDetails.trainingName = this.AddTrainingsForm.controls['sessionName'].value;
    this.saveTrainingDetails.trainerId = this.editTrainingDetails.trainerId;
    this.saveTrainingDetails.typeId = JSON.parse(this.AddTrainingsForm.controls['sessionType'].value);
    this.saveTrainingDetails.trainingModeId = JSON.parse(this.AddTrainingsForm.controls['sessionMode'].value);

    this.saveTrainingDetails.locationId = JSON.parse(this.AddTrainingsForm.controls['sessionLocation'].value);
    
    this.saveTrainingDetails.startDate = this.AddTrainingsForm.controls['startDate'].value;
    this.saveTrainingDetails.endDate = this.AddTrainingsForm.controls['endDate'].value;
    this.saveTrainingDetails.plannedResourcesCount = this.AddTrainingsForm.controls['noofPlannedResources'].value;
    this.saveTrainingDetails.prerequisiteTools = this.AddTrainingsForm.controls['toolsRequired'].value;
    this.saveTrainingDetails.trainingRecordingSharePointURL = this.AddTrainingsForm.controls['sessionURL'].value;
    this.saveTrainingDetails.attendeeEmails = this.emails;

    this.service.addTrainingDetails(this.saveTrainingDetails).subscribe(res => {
      this.toastr.success("Training edited Successfully");
    this.resetForm();
    const sendData = {
      value: this.trainingTypeId,
      name: this.trainingTypeName,
    }
    this.subCompetencyName=this.subCompetencyName.replace(/\//g, '');
    this.subCompetencyName=this.subCompetencyName.split(' ').join('');
    this.router.navigate([`Home/Competencies/${this.competencyname}/${this.subCompetencyName}/Trainings/${sendData.name}`]);

    })
   

  }

  copyTraining() {
    this.emailInput = this.AddTrainingsForm.controls['emailInputString'].value

    this.saveTrainingDetails.competencyId = JSON.parse(this.AddTrainingsForm.controls['serviceLines'].value);
    
    this.saveTrainingDetails.subCompetencyId = JSON.parse(this.AddTrainingsForm.controls['subServiceline'].value);
    
    this.saveTrainingDetails.trainingName = this.AddTrainingsForm.controls['sessionName'].value;
    this.saveTrainingDetails.trainerId = this.editTrainingDetails.trainerId;
    this.saveTrainingDetails.typeId = JSON.parse(this.AddTrainingsForm.controls['sessionType'].value);
    this.saveTrainingDetails.trainingModeId = JSON.parse(this.AddTrainingsForm.controls['sessionMode'].value);

    this.saveTrainingDetails.locationId = JSON.parse(this.AddTrainingsForm.controls['sessionLocation'].value);
    
    this.saveTrainingDetails.startDate = this.AddTrainingsForm.controls['startDate'].value;
    this.saveTrainingDetails.endDate = this.AddTrainingsForm.controls['endDate'].value;
    this.saveTrainingDetails.plannedResourcesCount = this.AddTrainingsForm.controls['noofPlannedResources'].value;
    this.saveTrainingDetails.prerequisiteTools = this.AddTrainingsForm.controls['toolsRequired'].value;
    this.saveTrainingDetails.trainingRecordingSharePointURL = this.AddTrainingsForm.controls['sessionURL'].value;
    this.saveTrainingDetails.attendeeEmails = this.emails;

    this.service.addTrainingDetails(this.saveTrainingDetails).subscribe(res => {
      this.toastr.success("Training created Successfully");
    this.resetForm();
    const sendData = {
      value: this.trainingTypeId,
      name: this.trainingTypeName,
    }
    this.subCompetencyName=this.subCompetencyName.replace(/\//g, '');
    this.subCompetencyName=this.subCompetencyName.split(' ').join('');
    this.router.navigate([`Home/Competencies/${this.competencyname}/${this.subCompetencyName}/Trainings/${sendData.name}`]);

    })
  }

  backToTrainingGrid() {
    const sendData = {
      value: this.trainingTypeId,
      name: this.trainingTypeName,
    }
    this.subCompetencyName=this.subCompetencyName.replace(/\//g, '');
    this.subCompetencyName=this.subCompetencyName.split(' ').join('');
    this.router.navigate([`Home/Competencies/${this.competencyname}/${this.subCompetencyName}/Trainings/${sendData.name}`]);
    this.viewButton = false
  }

}